/**
 * AR content for the "Èze – La Turbie" private excursion.
 *
 * Role: Arabic (MSA) translation of slugs/eze-la-turbie.ts, typed `ExcursionPage`
 * for the shared ExcursionSlugView.
 * Dependencies: slug-excursions (type), image. Slug mirrors FR (place names).
 */
import type { ExcursionPage } from "../slug-excursions";
import laturbie from "@/assets/images/excursions/destinations/laturbie.jpeg";

const page: ExcursionPage = {
  slug: "eze-la-turbie",
  hero: {
    title: "رحلة إيز – لا تربي",
    subtitle: "قرى معلّقة وإطلالات بانورامية وعبق المتوسط.",
    ctaPrimaryHref: "/reservation",
    ctaPrimaryLabel: "احجز الآن",
    ctaSecondaryHref: "/contact",
    ctaSecondaryLabel: "اطلب عرض سعر",
    image: laturbie,
  },
  highlights: {
    title: "أبرز المعالم",
    items: [
      { text: "إيز: قرية معلّقة وحديقة استوائية" },
      { text: "لا تربي: نصب جبال الألب وإطلالات على البحر" },
      { text: "طرق بانورامية على الكورنيش الكبير" },
      { text: "وقفات للتصوير تطلّ على البحر المتوسط" },
    ],
  },
  itinerary: {
    title: "برنامج مقترح",
    steps: [
      {
        title: "إيز",
        description: "الصعود إلى الحديقة والأزقّة والعطّار (اختياري)",
      },
      {
        title: "لا تربي",
        description: "وسط القرية ونصب أوغسطس (من الخارج)",
      },
    ],
  },
  practical: {
    title: "معلومات عملية",
    items: [
      { label: "المدة", value: "من 4 إلى 6 ساعات" },
      { label: "الانطلاق", value: "كان" },
      { label: "التضاريس", value: "بعض المنحدرات / الدرجات على الطريق" },
      { label: "تذاكر الحديقة", value: "دخول الحديقة الاستوائية غير مشمول" },
    ],
  },
};

export default page;
